const APP_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://api.mowasel.com',
};

export default APP_CONFIG;
